import { del, get, post } from './apiService';
import type {
  ListNotificationMutesResponse,
  NotificationMute,
} from '../types/notificationMute';

/**
 * Snoozes a chef's new-dish notifications for the caller ("Snooze this chef").
 * Idempotent — the backend returns the existing live mute if there is one, so
 * re-snoozing is safe. Returns the mute row.
 */
export async function snoozeChef(
  mutedProfileId: string,
): Promise<NotificationMute> {
  return post<NotificationMute>('/notification-mutes', { mutedProfileId });
}

/**
 * Un-snoozes a chef (soft delete server-side). Idempotent — a no-op 204 when
 * no live mute exists. Returns nothing.
 */
export async function unsnoozeChef(mutedProfileId: string): Promise<void> {
  return del<void>(`/notification-mutes/${mutedProfileId}`);
}

/**
 * Lists the caller's snoozed chefs, each with the chef's `mutedProfile`
 * preloaded for rendering. The FE derives the "# snoozed" count from the
 * array length.
 */
export async function getSnoozedChefs(): Promise<NotificationMute[]> {
  const res = await get<ListNotificationMutesResponse>('/notification-mutes');
  return res.mutes;
}
